module.exports = __webpack_public_path__ + "static/01-3c9bfc26844220188ee643837f16e8b1.jpg";